export enum HeaderState {
  notLogged = 'notLogged',
  logged = 'logged',
}
